import { render, staticRenderFns } from "./completed_health_check.vue?vue&type=template&id=5cf23a25&scoped=true"
import script from "./completed_health_check.vue?vue&type=script&lang=js"
export * from "./completed_health_check.vue?vue&type=script&lang=js"
import style0 from "./completed_health_check.vue?vue&type=style&index=0&id=5cf23a25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf23a25",
  null
  
)

export default component.exports